import { getPlatform } from './getPlatform';
import { sanitizeUrl } from '@payments-frontend/utils';

export type OpenLinkInGoOptions = {
    url: string;
    /**
     * If false is sent for an http link, it will open the link inside the webview within the application.
     * For non-http links, the flag value is ignored. If the flag is absent, the link will open in an external browser
     *
     */
    shouldOpenInSystemBrowser: boolean;
};

export const openLinkInGo = ({ url, shouldOpenInSystemBrowser }: OpenLinkInGoOptions) => {
    const { taxiApp } = window;
    let sanitizedUrl = sanitizeUrl(url);

    if (!taxiApp) {
        throw new Error('No taxiApp support in the current window');
    }

    const platform = getPlatform();

    const args: [string, boolean?] = [sanitizedUrl];

    if (platform === 'ios') {
        args.push(shouldOpenInSystemBrowser);
    }
    // On Android, the function does not accept the second argument
    // and always opens the link in the system browser.
    // Waiting for a fix https://st.yandex-team.ru/TAXIA-26974
    taxiApp.requestOpenUri(...args);
};
